import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjZoneS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_95842_35597)">
        <path
          d="M2 4.5C2 4.5 4 3.5 6 3.5C8 3.5 8 4.5 10 4.5C12 4.5 14 3.5 14 3.5V5.5C14 5.5 12 6.5 10 6.5C8 6.5 8 5.5 6 5.5C4 5.5 2 6.5 2 6.5L2 4.5Z"
          fill="#97B2C4"
        />
        <path
          d="M2 7.5C2 7.5 4 6.5 6 6.5C8 6.5 8 7.5 10 7.5C12 7.5 14 6.5 14 6.5V8.5C14 8.5 12 9.5 10 9.5C8 9.5 8 8.5 6 8.5C4 8.5 2 9.5 2 9.5L2 7.5Z"
          fill="currentcolor"
        />
        <path
          d="M2 10.5C2 10.5 4 9.5 6 9.5C8 9.5 8 10.5 10 10.5C12 10.5 14 9.5 14 9.5V11.5C14 11.5 12 12.5 10 12.5C8 12.5 8 11.5 6 11.5C4 11.5 2 12.5 2 12.5L2 10.5Z"
          fill="#97B2C4"
        />
      </g>
      <defs>
        <clipPath id="clip0_95842_35597">
          <rect width="12" height="10" fill="white" transform="translate(2 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconGeoObjZone = createIcon({
  l: IconGeoObjZoneS,
  m: IconGeoObjZoneS,
  s: IconGeoObjZoneS,
  xs: IconGeoObjZoneS,
  name: 'IconGeoObjZone',
})
